import { toast } from "react-toastify";
import getErrorMessage from "./getErrorMessage";
import isConnectivityError from "../helpers/isConnectivityError";
import { isBackendOffline } from "../helpers/backendStatus";

const toastError = (err, options = {}) => {
	// Backend fora do ar não vira toast: a sidebar já mostra "Conexão perdida"
	if (isConnectivityError(err) || isBackendOffline()) return;
	const errorMsg = err?.response?.data?.error;
	toast.error(getErrorMessage(err), {
		toastId: errorMsg || undefined,
		autoClose: 10000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: false,
		draggable: true,
		progress: undefined,
		theme: "light",
		...options,
	});
};

export default toastError;
